import React from "react";
import {
  AuthControllerApi,
  CertificateControllerApi,
  ContactControllerApi,
  OrderControllerApi,
  StockControllerApi
} from "../api";

interface ApiContextSchema {
  authApi: AuthControllerApi;
  orderApi: OrderControllerApi;
  contactApi: ContactControllerApi;
  stockApi: StockControllerApi;
  certificateApi: CertificateControllerApi;
}

export const ApiContext = React.createContext<ApiContextSchema>({} as ApiContextSchema);
